define('modernizr', [], function () {
	// Modernizr should be loaded synchronously like requireLib
	return window.Modernizr; 
});

